import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import { StreamActions } from "@hotwired/turbo"
import morph from "./morph"

import Alert from "bootstrap/js/dist/alert"

import "../scss/courses.scss";

Stimulus.load(definitionsFromContext(require.context("./controllers", true, /\.js$/)))

StreamActions.update_module_link = function(){
  // Handles updates of the module link (only status so far)
  // We need to update Stimulus values, and the controller will do the rest
  document
    .querySelectorAll(`[data-module-link-id-value="${this.getAttribute('id')}"]`)
    .forEach((element) => {
      element.setAttribute('data-module-link-status-value', this.getAttribute('status'));
    });
}

StreamActions.morph = function () {
  morph(this);
}
